const sameWidthModifier: any = {
  enabled: true,
  name: 'sameWidth',
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn: ({ instance, state }: any) => {
    const triggerReferenceWidth = `${state.rects.reference.width}px`

    if (state.styles.popper.width !== triggerReferenceWidth) {
      state.styles.popper.width = triggerReferenceWidth
      // force update the popper instance, so it can reposition the dropdown properly
      instance.update()
    }
  },
}

const defaultModifiers = [
  {
    name: 'offset',
    options: {
      offset: [0, 10],
    },
  },
  { name: 'preventOverflow', options: {} },
  { name: 'flip', options: {} },
]

interface CustomModifierFlags {
  sameWidth: boolean
}

export default function dropdownPopperModifiers({ sameWidth }: CustomModifierFlags) {
  let modifiers = [...defaultModifiers]

  if (sameWidth) {
    modifiers = [...modifiers, sameWidthModifier]
  }

  return modifiers
}
